import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class FulfillmentOrderApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  get(params :{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/orders/fulfillment-orders`,
      {
        params,
      },
    );
  }

  getAll(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/orders/fulfillment-order-items/all`,
      {
        params,
      },
    );
  }

  delete(id :number) :Observable<any> {
    return this.apiService.delete(
      `${this.environment.urlV2}/orders/fulfillment-orders/${id}`,
    );
  }

  update(id :number, data :any) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/orders/fulfillment-orders/${id}`,
      data,
    );
  }

  updateStatus(id :number, data :any) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/orders/fulfillment-orders/${id}/status`,
      data,
    );
  }

  create(data :any) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/orders/fulfillment-orders`,
      body: data,
    });
  }

  autoGenerateFulfillmentOrder(data :any) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/orders/fulfillment-orders/auto-generate-for-sales-orders`,
      body: data,
    });
  }

  processFulfillmentOrderChannelAction(data :any) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/orders/fulfillment-orders/process-push-unpush-fulfillment-channel-action`,
      body: data,
    });
  }

  getById(data :{
    id :number;
    params ?:{ [param :string] :string | string[] };
  }) :Observable<any> {
    const { id, params } = data;

    return this.apiService.get(
      `${this.environment.urlV2}/orders/fulfillment-orders/${id}`,
      {
        params,
      },
    );
  }

  getNextOrderKey(data :{ salesOrderId :number }) :Observable<any> {
    const { salesOrderId } = data;

    return this.apiService.get(
      `${this.environment.urlV2}/orders/fulfillment-orders/next-order-key/${salesOrderId}`,
    );
  }

  createInvoice(id: number) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/orders/fulfillment-orders/${id}/invoice`,
    );
  }
}
